<template>
    <div ref="slider" class="vue-daterange" />
</template>

<script>
import { debounce } from 'lodash';
import moment from 'moment';
import noUiSlider from 'nouislider';
import { monthDiff, plotYears } from '../../../components/date-range';

export default {
    props: {
        rangeStart: {
            type: String,
            required: true
        },
        rangeEnd: {
            type: String,
            required: true
        },
        filterStart: {
            type: String,
            default: null
        },
        filterEnd: {
            type: String,
            default: null
        }
    },

    computed: {
        range() {
            return {
                start: moment(this.rangeStart, 'YYYY-MM-DD').format('YYYY-MM'),
                end: moment(this.rangeEnd, 'YYYY-MM-DD').format('YYYY-MM')
            }
        },

        filter() {
            return {
                start: this.filterStart ? moment(this.filterStart, 'YYYY-MM-DD').format('YYYY-MM') : this.range.start,
                end: this.filterEnd ? moment(this.filterEnd, 'YYYY-MM-DD').format('YYYY-MM') : this.range.end
            }
        }
    },

    watch: {
        rangeStart() {
            this.refresh();
        },
        rangeEnd() {
            this.refresh();
        },
        filterStart() {
            this.refresh();
        },
        filterEnd() {
            this.refresh();
        }
    },

    mounted() {
        const start = this.range.start;

        noUiSlider.create(this.$refs.slider, {
            connect: true,
            step: 1,
            range: {
                min: 0,
                max: monthDiff(this.range.start, this.range.end) || 1,
            },
            start: [monthDiff(this.range.start, this.filter.start), monthDiff(this.range.start, this.filter.end)],
            pips: {
                mode: 'values',
                values: plotYears(this.range.start, this.range.end),
                format: {
                    to(value) {
                        return moment(start).add(value, 'month').format('YYYY');
                    },
                },
            },
        });

        const thottledUpdate = debounce(this.updateParent, 1000);

        this.$refs.slider.noUiSlider.on('update', (values) => {
            const momentStart = moment(this.range.start, 'YYYY-MM').add(Number(values[0]), 'month');
            const momentEnd = moment(this.range.start, 'YYYY-MM').add(Number(values[1]), 'month');

            const filterStart = momentStart.format('YYYY-MM') === this.range.start ? null : momentStart.startOf('month').format('YYYY-MM-DD');
            const filterEnd = momentEnd.format('YYYY-MM') === this.range.end ? null : momentEnd.endOf('month').format('YYYY-MM-DD');

            // Events for showing active range
            this.$emit('update:filterStart', filterStart);
            this.$emit('update:filterEnd', filterEnd);
            thottledUpdate(filterStart, filterEnd);
        });
    },

    methods: {
        updateParent(start, end) {
            this.$emit('updated', { start, end });
        },

        refresh() {
            this.$refs.slider.noUiSlider.updateOptions({
                range: {
                    min: 0,
                    max: monthDiff(this.range.start, this.range.end) || 1,
                },
                start: [
                    monthDiff(this.range.start, this.filter.start),
                    monthDiff(this.range.start, this.filter.end)
                ]
            }, false);
        }
    },

    destroy() {
        this.$refs.slider.noUiSlider.destroy();
    }
};
</script>

<style lang="scss">
    .vue-daterange .noUi-value {
        top: 20px;
    }
</style>
